import { toast } from 'react-toastify';
import { setCookie } from './persistor';
import { redirectToAutoUpgrade } from './url';
import { getNotifMsg } from './locale';

export const handleErrors = (error, locale = 'fa') => {
  const code = error.response?.status;

  if (error.message === 'Network Error') {
    toast.error(getNotifMsg('SERVER_ERROR', locale));
    return;
  }

  if (
    code === 403 &&
    error.response.data?.data?.message === 'upgrade package'
  ) {
    toast.error(getNotifMsg('UPGRADE_PACKAGE', locale));
    return;
  }

  switch (code) {
    case 500:
      toast.error(getNotifMsg('SERVER_ERROR_TRY_AGAIN', locale));
      break;

    case 403:
      toast.error(getNotifMsg('INVALID_ACCESS_LEVEL', locale));
      break;

    case 401:
      if (process.env.NODE_ENV === 'development') {
        setCookie('isLoggedIn', 'false', 30);
      }
      redirectToAutoUpgrade('/login');
      break;

    case 404:
      toast.error(getNotifMsg('CONTENT_NOT_FOUND', locale));
      break;

    case 400:
      toast.error(getNotifMsg('SENT_REQUEST_NOT_CORRECT', locale));
      break;

    case 429:
      toast.error(getNotifMsg('TOO_MANY_REQUESTS', locale));
      break;

    case 413:
      toast.error(getNotifMsg('LARGE_FILE_UPLOADED', locale));
      break;

    default:
      break;
  }
};

export const responseDelayHandleError = (error, locale = 'fa') => {
  const errorMessage = error.response?.data?.error?.[0]?.message;
  const errorStatus = error.response?.status;

  switch (errorMessage) {
    case 'فیلد مورد نظر خالی می باشد':
      toast.error(getNotifMsg('RESPONSE_DELAY_FORM_ERROR', locale));
      break;
    case 'لطفا فیلد مورد نظر را در قالب صحیح ارسال کنید':
      toast.error(getNotifMsg('RESPONSE_DELAY_FORM_TYPE_ERROR', locale));
      break;
    default:
      break;
  }

  switch (errorStatus) {
    case 404:
      toast.error(getNotifMsg('CONTENT_NOT_FOUND', locale));
      break;
    default:
      break;
  }
};

export const inputsErrorsHandler = (errorMessage, locale = 'fa') => {
  toast.error(getNotifMsg(errorMessage, locale));
};
